import Dialog from "@hydrologiq/shared/chakra/Dialog"
import { Box } from "@chakra-ui/react"

interface FullscreenDialogProps {
  open: boolean
  onClose: () => void
  title?: string
  children: React.ReactNode
}

export const FullscreenDialog = ({ open, onClose, title, children }: FullscreenDialogProps) => {
  return (
    <Dialog open={open} onClose={onClose} title={title ?? ""} fullscreen={true}>
      <Box width="100%" height="100%">
        {children}
      </Box>
    </Dialog>
  )
}
